import ContentLayout from "../components/UI/Layout/ContentLayout";
import PageLayout from "../components/UI/Layout/PageLayout";
import HeaderLayout from "../components/UI/Layout/HeaderLayout";
import ContactShow from "../components/CarnetAdresse/ContactShow";

export default function CarnetAdressePage() {
  return (
    <PageLayout isBailleur>
      <ContentLayout
        header={
          <HeaderLayout
            title="Carnet d'adresses"
            breadcrumb={[
              { label: "Tableau de bord", to: "/bailleur" },
              { label: "Carnet d'adresses" },
            ]}
          />
        }
        body={
          <div className="content">
            <ContactShow />
          </div>
        }
      />
    </PageLayout>
  );
}
